import axios, { AxiosError } from 'axios';
import { buildURL } from '../webservice';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_V2_URL!;

const fetchBanks = async (authToken: string) => {
    try {
        const url = buildURL(BASE_URL, '/banks');

        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };

        const response = await axios.get(url, config);

        return response.data;
    } catch (err) {
        console.error('Error al obtener la lista de bancos:', err);
        if (err instanceof AxiosError) {
            return err.response?.data || [];
        }
        return [];
    }
};

export { fetchBanks };
